import React, { Suspense, lazy } from 'react';

const SlickSlider = lazy(() => import('react-slick').then(module => ({ default: module.default })));

const BasicSlider = React.forwardRef(({ children, className, ...props }, ref) => {
  const isSsr = typeof window === 'undefined';
  if (isSsr) return null;

  return (
    <Suspense fallback={null}>
      <SlickSlider {...props} ref={ref}>
        {children}
      </SlickSlider>
    </Suspense>
  );
});

BasicSlider.displayName = 'Slider';

export default BasicSlider;
